
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Parathyroid_carcinoma',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Parathyroid_carcinoma.vue